import Header from "../components/Header";
import Footer from "../components/Footer";
import BottomTabBar from "../components/BottomTabBar";
import LegalShell from "../components/LegalShell";
import { Mail, Instagram, MessageCircle } from "lucide-react";

export default function Contact() {
  return (
    <div className="warm-bg min-h-screen">
      <Header />
      <LegalShell title="Contact us" subtitle="We read every message.">
        <p>
          Got a question, bug report, partnership idea, or want to ask for a
          refund? Hit us up — we usually reply within 1–2 business days.
        </p>

        <div className="not-prose grid grid-cols-1 sm:grid-cols-3 gap-3 my-8">
          <ContactCard
            icon={<Mail className="w-5 h-5" />}
            label="Email"
            value="playvibcheck@gmail.com"
            href="mailto:playvibcheck@gmail.com"
            testid="contact-email"
          />
          <ContactCard
            icon={<Instagram className="w-5 h-5" />}
            label="Instagram"
            value="@play.vibcheck"
            href="https://instagram.com/play.vibcheck"
            testid="contact-instagram"
          />
          <ContactCard
            icon={<MessageCircle className="w-5 h-5" />}
            label="DM us anything"
            value="We answer DMs first"
            href="https://instagram.com/play.vibcheck"
            testid="contact-dm"
          />
        </div>

        <h2>For specific things</h2>
        <ul>
          <li>
            <b>Refunds</b>: include your Stripe receipt or transaction id. See{" "}
            <a href="/refund-policy">Refund Policy</a>.
          </li>
          <li>
            <b>Privacy / data deletion</b>: tell us the email you used or the
            device id (in app settings later). See{" "}
            <a href="/privacy">Privacy Policy</a>.
          </li>
          <li>
            <b>Bug reports</b>: a quick screenshot + a one-liner ("happens when I
            …") is gold for us.
          </li>
          <li>
            <b>Press / partnerships</b>: same email, prefix the subject with
            [PARTNERSHIP].
          </li>
        </ul>
      </LegalShell>
      <Footer />
      <BottomTabBar />
    </div>
  );
}

function ContactCard({ icon, label, value, href, testid }) {
  return (
    <a
      href={href}
      target={href.startsWith("http") ? "_blank" : undefined}
      rel={href.startsWith("http") ? "noopener noreferrer" : undefined}
      className="rounded-2xl p-4 border border-white/10 bg-white/5 hover:bg-white/8 transition-colors no-underline"
      data-testid={testid}
    >
      <div className="inline-flex w-9 h-9 rounded-xl bg-gradient-to-br from-[#FF4D8D] to-[#7B61FF] items-center justify-center text-white mb-3 shadow-[0_0_18px_rgba(255,77,141,0.4)]">
        {icon}
      </div>
      <div className="text-[10px] uppercase tracking-[0.2em] text-[#9B98AE] font-bold mb-1">
        {label}
      </div>
      <div className="text-white text-sm font-semibold break-all">{value}</div>
    </a>
  );
}
